import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledMeasureResult = styled.div<{$emptyMeasure: boolean}>(
    ({theme: {spacing}, $emptyMeasure}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${spacing * 2}px;
        width: 100%;
        height: 100%;
        overflow-y: scroll;

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
            max-height: calc(100vh - 350px);
            overflow-y: scroll;
        }

        ${$emptyMeasure &&
        css`
            display: flex;
            justify-content: center;
            align-items: center;
        `}
    `
)

export const StyledMeasureResultsContainer = styled(Flexbox)`
    ${({theme}) => css`
        padding: ${theme.spacing * 6}px;
        height: calc(100vh - 83px);
        background: ${theme.palette.neutral['200']};
        overflow: scroll;

        @media (max-width: 768px) {
            padding: 0;
            height: calc(100vh - 67px);
        }
    `}
`

export const StyledMeasureResultsWrapper = styled.div`
    ${({theme}) => css`
        background: ${theme.palette.neutral.white};
        border-radius: 8px;
        box-shadow: ${theme.shadows.sm};
        border: 1px solid ${theme.palette.neutral['200']};
        height: calc(100vh - 200px);
        transition: all 0.3s ease;
        width: 100%;

        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr auto;

        & > :nth-child(1) {
            padding: ${theme.spacing * 5}px ${theme.spacing * 6}px ${theme.spacing * 5}px ${theme.spacing * 6}px;
        }

        & > :nth-child(2) {
            padding: 0 ${theme.spacing * 6}px ${theme.spacing * 6}px ${theme.spacing * 6}px;
        }

        @media (max-width: 768px) {
            border-radius: 16px;
            padding: 0;
            margin-bottom: ${theme.spacing * 4}px;
            height: 100%;
            width: 100%;

            & > :nth-child(1) {
                padding: ${theme.spacing * 5}px ${theme.spacing * 4}px;
            }

            & > :nth-child(2) {
                padding: 0 0 ${theme.spacing * 6}px 0;
            }
        }

        @media (max-width: 344px) {
            & > :nth-child(1) {
                padding: ${theme.spacing * 5}px ${theme.spacing * 2}px;
            }
        }
    `}
`
